import { Component, OnInit } from '@angular/core';
import { AuthAccessProvider } from '../core/core.auth';
import { MessageProvider } from '../service/message.service'
import { UserService} from '../service/user.service';
import { CheckhrService} from '../service/checkhr.service';
import { Router } from '@angular/router';
import { UserContext, BaseComponent, UserInfo } from '../core/core.component';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.css']
})
export class AdministrationComponent  extends BaseComponent implements OnInit 
{
    userContext: UserContext;
    userInfo: UserInfo;
    displayReports: string = "";
    displayUsersManagement: string = "";
    displayUsersStatistics: string = "";
    displayCheckhr: string = "";
    displayEquipments: string = "";
    reportsInitialized: boolean = false;
    usersManagementInitialized: boolean = false;
    usersStatisticsInitialized: boolean = false;
    checkhrInitialized: boolean = false;
    equipmentsInitialized: boolean = false;
  
    checkhrAlerts: number = 0;
  
    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider,
            private userService: UserService,
          	private checkhrService: CheckhrService)
    { 
        super(authAccess, router, messageProvider);
        this.messageProvider.clearAll();
    }

    ngOnInit() 
    {
        this.userContext = this.authAccess.getUserContext();
        if(this.userContext == null) {    
            this.authAccess.invalidate();
        } else {
            this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
                result => {
                    this.userInfo = result;
                    if (this.userInfo.admin) {
                        this.loadCheckhrAlerts();
                        this.display('statistics');
                    } else {
                        this.display(this.userInfo.managedUsers.length ? 'reports' : 'equipments');
                    }
                },
                error => {
                    this.handleError(error);
                }
            );
        }
    }
  

    backToHome() {
        this.router.navigate(["/"]);
    }
    
   display(section: string) 
   {
      this.displayReports = "";
      this.displayUsersManagement = "";
      this.displayUsersStatistics = "";
      this.displayCheckhr = "";
      this.displayEquipments = "";
      if(section == "reports") {
          this.displayReports = "active";
          this.reportsInitialized = true;
      } else if(section == "users") {
          this.displayUsersManagement = "active";
          this.usersManagementInitialized = true;
      } else if(section == "statistics") {
          this.displayUsersStatistics = "active";
          this.usersStatisticsInitialized = true;
      } else if(section == "checkhr") {
          this.displayCheckhr = "active";
          this.checkhrInitialized = true;
      } else if(section == "equipments") {
          this.displayEquipments = "active";
          this.equipmentsInitialized = true;
      }
   }
  
   loadCheckhrAlerts() {
     this.checkhrService.getCheckhrAlertsCount(this.userContext.srmToken).subscribe(
       result => {
         const alerts = parseInt(result.message, 10);
         if (!isNaN(alerts)) {
           this.checkhrAlerts = alerts;
         }
       },
       error => {
         this.handleError(error);
       });
   }
}



// WEBPACK FOOTER //
// ./src/app/administration/administration.component.ts